import React, { useEffect } from 'react'

import { Breadcrumb, Layout } from 'antd'
import { get, map } from 'lodash'
import { useTranslation } from 'react-i18next'
import ReactMarkdown from 'react-markdown'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useHistory, useParams } from 'react-router-dom'
import rehypeRaw from 'rehype-raw'
import gfm from 'remark-gfm'

import { MenuSidebar, GuidelineTopic } from '../components'
import { getCategory } from '../redux/actions/category'
import ArticleLayout from '../templates/Article'
import { getConfig, getContent } from '../utils'

const { Content, Sider } = Layout

const Article = () => {
  const { i18n } = useTranslation()
  const dispatch = useDispatch()
  const [commonContent, categoryContent] = useSelector((state) => [
    get(state, 'common.data', {}),
    get(state, 'category.data', []),
  ])

  useEffect(() => {
    dispatch(getCategory(i18n.language))
  }, [i18n.language])

  const slug = useParams()
  const content = getContent(slug, categoryContent)

  const history = useHistory()

  const onSelectMenu = ({ key }) => {
    history.push(`/category${key}`)
  }

  const dataMenu = categoryContent.map((v, k) => ({
    title: get(commonContent, `${k === 0 ? 'quickstartGuides' : 'popularTopics'}`, ''),
    list: v,
  }))

  const slugArray = get(content, 'slugArray', [])

  return (
    <ArticleLayout
      title={get(commonContent, 'title', '')}
      placeholder={get(commonContent, 'search_placeholder', '')}
    >
      <Layout className="container-fluid">
        <Sider width={430} className="article__sidebar">
          <MenuSidebar
            defaultSelectedKeys={`${slugArray.reduce((a, c) => `${a}/${c.slug}`, '')}`}
            onSelect={onSelectMenu}
            dataMenu={dataMenu}
          />
        </Sider>
        <Layout className="article__content">
          <Breadcrumb style={{ margin: '32px 0' }}>
            {map(slugArray, (s, key) => (
              <Breadcrumb.Item key={key} id={`${key}`}>
                {key === 0 || key === slug.length - 1 ? (
                  <Link to={`/category/${s.slug}`}>
                    <span>{s.label}</span>
                  </Link>
                ) : (
                  s.label
                )}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
          <Content>
            <ReactMarkdown
              remarkPlugins={[gfm]}
              rehypePlugins={[rehypeRaw]}
              transformImageUri={(src) => `${getConfig('HOST_API')}${src}`}
            >
              {get(content, 'content', '')}
            </ReactMarkdown>
            <GuidelineTopic options={get(content, 'submenu', [])} mainSlug={slugArray[0].slug} />
          </Content>
        </Layout>
      </Layout>
    </ArticleLayout>
  )
}

export default Article
